import React from "react";
import "./Not_Found.css";
import { useNavigate } from "react-router-dom";

const Not_Found = () => {
    const navigate = useNavigate();

    return (
        <section className="notfound_sec">
            <div className="notfound_box">
                <h1>404</h1>
                <h3>Page Not Found</h3>
                <p>The page you are looking for doesn't exist.</p>
                <button onClick={() => navigate(-1)}>
                    Go Back        </button>
            </div>
        </section>
    );
};

export default Not_Found;